export const authTypes = {
    success: "SUCCESS_LOGIN",
    loading: "LOADING_LOGIN",
    successLogout: "SUCCESS_LOGOUT",
};
